import type { State } from '../State';
import { isPromoReady } from '../promo/promo.getters';
import { stickerCampaignSchedule } from './stickers.ruleset';

/**
 * Check campaign eligibility and the weekly allowance on a normal launch.
 * @param state Player promo history, shared by normal and payload launches.
 * @param now Current server time in milliseconds.
 * @returns Whether a normal launch may show the popup this week.
 */
export function canShowStickerPopupOnLaunch(
  state: State,
  now: number,
): boolean {
  // The schedule owns the campaign weeks, including their exclusive ends.
  const event = stickerCampaignSchedule.getCurrentEvent(now);
  if (!event) return false;

  // Respect the campaign window and the promo's active flag.
  if (!isPromoReady(state, 'sponsoredStickers2026', now)) return false;

  // Any display consumes the normal-launch allowance until the next boundary.
  const shownAt = state.promo.sponsoredStickers2026?.shownAt ?? 0;

  // A display before this scheduled week leaves the current allowance unused.
  return shownAt < event.start;
}
